export const Brands: {[host: string]: string} = {
    "pfiverify.com": "PFIVerify",
    "www.pfiverify.com": "PFIVerify",
    "members.pfiverify.com": "PFIVerify",
    "stage.pfiverify.com": "PFIVerify",
    "financeify.co": "Financeify",
    "www.financeify.co": "Financeify",
    "financeify.com": "Financeify",
    "www.financeify.com": "Financeify",
    "stage.financeify.com": "Financeify",
    "members.financeify.co": "Financeify",
    "stage.financeify.co": "Financeify",
    "verifyfinancialprofile.com": "VFP",
    "www.verifyfinancialprofile.com": "VFP",
    "members.verifyfinancialprofile.com": "VFP",
    "pfisimplify.com": "PFISimplify",
    "www.pfisimplify.com": "PFISimplify",
    "members.pfisimplify.com": "PFISimplify",
    "stage.pfisimplify.com": "PFISimplify",
    "getpfiverify.com": "GetPFIVerify",
    "www.getpfiverify.com": "GetPFIVerify",
    "members.getpfiverify.com": "GetPFIVerify",
    "finsightsai.com": "Finsights",
    "www.finsightsai.com": "Finsights",
    "members.finsightsai.com": "Finsights",
    "stage.finsightsai.com": "Finsights",
    "getfinanceify.com": "GetFinanceify",
    "www.getfinanceify.com": "GetFinanceify",
    "members.getfinanceify.com": "GetFinanceify",
    "www.pfi-verify.com": "PFIVerify",
    "stage.pfi-verify.com": "PFIVerify",
    "www.myfinanceify.com": "MyFinanceify",
    "stage.myfinanceify.com": "MyFinanceify",
    "www.financeify.net": "Financeify",
    "financeify.net": "Financeify",
    "financialinsightai.com": "FinancialInsight",
    "www.financialinsightai.com": "FinancialInsight",
    "members.financialinsightai.com": "FinancialInsight",
    "stage.financialinsightai.com": "FinancialInsight"
}

export enum EBrands {
    PFIVerify = "PFIVerify",
    GetPFIVerify = "GetPFIVerify",
    Financeify = "Financeify",
    GetFinanceify = "GetFinanceify",
    VFP = "VFP",
    Finsights = "Finsights",
    PFISimplify = "PFISimplify",
    PFIVerifyDOVentures = "PFIVerifyDOVentures",
    MyFinanceifyDOVentures = "MyFinanceifyDOVentures",
    FinancialInsight = "FinancialInsight",
}

export interface IHideForBrand {
    hide: boolean
}